import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import './assets/css/fonts/fontStyles.css';
import { BaseUrlProvider } from './context/AppContext';

/* ================= STUDENT – PUBLIC ================= */
import Home from "./screens/student/home/Home";
import About from "./screens/student/about/About";
import GetInTouch from "./subscreens/student/GetInTouch";
import Solutions from "./screens/student/solutions/Solutions";
import Contact from "./screens/student/contact/Contact";
import Donor from "./screens/student/donorscreen/Donor";
import NGO from "./screens/student/NgoScreen/Ngo";
// import Blogs from "./screens/student/blogs/Blogs";

/* ==================NOT FOUND PAGE ==================*/

import NotFound from "./components/notfound/NotFound";

/* =================== FOOTER DETAIL PAGES =================*/
//
import StoriesDetail from "./screens/student/blogs/StoriesDetail";
// import StoriesSection from "./screens/student/blogs/StoriesSection";

import AdminVerification from "./components/student/footer/featutres/AdminVerification";
import StudentSupportRequests from "./components/student/footer/featutres/StudentSupportRequests";
import PortalOfStudent from "./components/student/footer/resources/PortalOfStudent";
import DonorPortal from "./components/student/footer/resources/DonorPortal";
import NgoResourscePortal from "./components/student/footer/resources/NgoResourcePortal";
import TrackingDonations from "./components/student/footer/featutres/TrackingDonations";
import DonorContribution from "./components/student/footer/featutres/DonorContribution";

/* ================= STUDENT – DASHBOARD ================= */
import StudentLogin from './screens/student/dashboard/auth/StudentLogin';
import Studentsignup from './screens/student/dashboard/auth/Studentsignup';
import Dashboard from "./screens/student/dashboard/Dashboard";
import DonorDispute from "./screens/student/dashboard/donordispute/DonorDispute";
import MyRequests from "./screens/student/dashboard/myrequests/MyRequests";
import StudentProfile from "./screens/student/dashboard/profile/StudentProfile";
import History from "./screens/student/dashboard/history/History";
import NotificationDropdown from "./screens/student/dashboard/notificationdropdown/NotificationDropdown";
import StudentNotification from "./screens/student/dashboard/notificationdropdown/StudentNotifications";
import Settings from "./screens/student/dashboard/settings/Settings";
import Ticketsystem from "./screens/student/dashboard/ticketsystem/Ticketsystem";
// import Blogsdetail from './components/blogs/Blogsdetail';
/* ================= DONOR ================= */
import DonorDashboard from "./screens/donor/dashboard/Dashboard";
import BrowseCases from "./screens/donor/dashboard/BrowseCases";
import DonationHistory from "./screens/donor/dashboard/DonationHistory";
import SupportTicket from "./screens/donor/dashboard/SupportTicket";
import MyLevel from "./screens/donor/dashboard/MyLevel";
import MyRewards from "./screens/donor/dashboard/MyRewards";
import Analytics from "./screens/donor/dashboard/Analytics";
import DonorProfile from "./screens/donor/dashboard/donorprofile/DonorProfile";
// import NotificationDropdown from "./screens/donor/dashboard/NotificationDropdown";
import AllNotifications from "./screens/donor/dashboard/AllNotifications";
import DonorRegister from "./screens/donor/auth/DonorRegister";
import DonorLogin from "./screens/donor/auth/DonorLogin";

/* ================= ADMIN ================= */
import AdminLogin from "./screens/admin/auth/Login";
import AdminDashboard from "./screens/admin/dashboard/Dashboard";
import SubAdmins from "./screens/admin/dashboard/subAdmins/SubAdmins";
import StudentMGMT from "./screens/admin/dashboard/studentmanagement/StudentManagement";
import DonorList from "./screens/admin/dashboard/donorlist/DonorList";
import DonorLevels from "./screens/admin/dashboard/donorLevels/DonorLevels";
import NGOlist from "./screens/admin/dashboard/NGOlist/NGOlist";
import Report from "./screens/admin/dashboard/report/Report";
import Donations from "./screens/admin/dashboard/donations/Donations";
import Disputes from "./screens/admin/dashboard/disputes/Disputes";
import ProfilePage from "./screens/admin/dashboard/profile/ProfilePage";
import Notifications from "./screens/admin/dashboard/notifications/Notifications";
import SupportSystem from "./screens/admin/dashboard/supportSystem/SupportSystem";
import BlogManagement from "./screens/admin/dashboard/blogManagement/BlogManagement";

/* ================= NGO ================= */
import NgoDashboard from "./screens/Ngo/controlpanel/ngodashboard/NgoDashboard";
import NgoCaseVerification from "./screens/Ngo/controlpanel/ngocaseverification/NgoCaseVerification";
import DonationTracking from "./screens/Ngo/controlpanel/donationtracking/DonationTracking";
import NgoFundWallet from "./screens/Ngo/controlpanel/ngofundwallet/NgoFundWallet";
import FundDistribution from "./screens/Ngo/controlpanel/funddistribution/FundDistribution";
import NgoReports from "./screens/Ngo/controlpanel/ngoreports/NgoReports";
import NgoDisputes from "./screens/Ngo/controlpanel/ngodisputes/NgoDisputes";
import DonorRewardsLevel from "./screens/Ngo/controlpanel/donorrewards&level/DonorRewardsLevel";
import NgoProfile from "./screens/Ngo/controlpanel/ngoprofile/NgoProfile";
import NgoNotification from "./screens/Ngo/controlpanel/ngonotification/NgoNotification";
import NgoAuth from "./screens/Ngo/auth/NgoAuth";
import Payout from "./screens/Ngo/controlpanel/payout/Payout";
import NgoSetting from './screens/Ngo/controlpanel/ngosetting/NgoSetting';
import Blogs from "./screens/student/blogs/Blogs";
import BlogDetail from "./screens/student/blogs/BlogDetail";
function App() {
  return (
    // <AppProvider>
    <BaseUrlProvider>
      <Routes>
        {/* ===== PUBLIC ===== */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/get-in-touch" element={<GetInTouch />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donor" element={<Donor />} />
        <Route path="/ngo" element={<NGO />} />
        {/* <Route path="/blogs" element={<Blogs />} /> */}
          <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />

        {/*========================FOOTER DEATAIL PAGES ================*/}

        <Route path="/admin-verification" element={<AdminVerification />} />
        <Route path="/student-support" element={<StudentSupportRequests />} />
        <Route path="/student-portal" element={<PortalOfStudent />} />
        <Route path="/Donor-portal" element={<DonorPortal />} />
        <Route path="/Ngo-portal" element={<NgoResourscePortal />} />
        <Route path="/donation-tracking" element={<TrackingDonations />} />
        <Route path="/donor-contribution" element={<DonorContribution />} />

        {/* ===== STUDENT ===== */}
        <Route path="/student/login" element={<StudentLogin />} />
        <Route path="/student/signup" element={<Studentsignup />} />
        <Route path="/student/dashboard" element={<Dashboard />} />
        <Route path="/student/disputes" element={<DonorDispute />} />
        <Route path="/student/myrequests" element={<MyRequests />} />
        <Route path="/student/profile" element={<StudentProfile />} />
        <Route path="/student/history" element={<History />} />
        <Route path="/student/notifications" element={<NotificationDropdown />} />
        <Route path="/student/studentnotifications" element={<StudentNotification />} />
        <Route path="/student/settings" element={<Settings />} />
        <Route path="/student/ticketsystem" element={<Ticketsystem />} />
        

        {/* ===== DONOR ===== */}
        <Route path="/donor/login" element={<DonorLogin />} />
        <Route path="/donor/register" element={<DonorRegister />} />
        <Route path="/donor/dashboard" element={<DonorDashboard />} />
        <Route path="/donor/browse-cases" element={<BrowseCases />} />
        <Route path="/donor/donation-history" element={<DonationHistory />} />
        <Route path="/donor/support-ticket" element={<SupportTicket />} />
        <Route path="/donor/my-level" element={<MyLevel />} />
        <Route path="/donor/analytics" element={<Analytics />} />
        <Route path="/donor/profile" element={<DonorProfile />} />
        <Route path="/donor/allnotifications" element={<AllNotifications />} />
        {/* <Route path="/donor/all-notifications" element={<AllNotifications />} /> */}

        {/* ===== ADMIN ===== */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/studentmgmt" element={<StudentMGMT />} />
        <Route path="/admin/donations" element={<Donations />} />
        <Route path="/admin/donorlist" element={<DonorList />} />
        <Route path="/admin/ngolist" element={<NGOlist />} />
        <Route path="/admin/report" element={<Report />} />
        <Route path="/admin/donor-levels-rewards" element={<DonorLevels />} />
        <Route path="/admin/profile" element={<ProfilePage />} />
        <Route path="/admin/disputes" element={<Disputes />} />
        <Route path="/admin/sub-admins" element={<SubAdmins />} />
        <Route path="/admin/notifications" element={<Notifications />} />
        <Route path="/admin/blog-management" element={<BlogManagement />} />
        <Route path="/admin/support-system" element={<SupportSystem />} />


        {/* ===== NGO ===== */}
        <Route path="/ngo-auth" element={<NgoAuth />} />
        <Route path="/ngo/dashboard" element={<NgoDashboard />} />
        <Route path="/ngo/allcases" element={<NgoCaseVerification />} />
        <Route path="/ngo/donationtracking" element={<DonationTracking />} />
        <Route path="/ngo/ngofund" element={<NgoFundWallet />} />
        <Route path="/ngo/funddistribution" element={<FundDistribution />} />
        <Route path="/ngo/reports" element={<NgoReports />} />
        <Route path="/ngo/disputes" element={<NgoDisputes />} />
        <Route path="/ngo/profile" element={<NgoProfile />} />
        <Route path="/ngo/donorlevels" element={<DonorRewardsLevel />} />
        <Route path="/ngo/notification" element={<NgoNotification />} />
        <Route path="/ngo/payout" element={<Payout />} />
        <Route path="/ngo/setting" element={<NgoSetting />} />

        {/* ===== DONOR ===== */}
        <Route path="/donor/login" element={<DonorLogin />} />
        <Route path="/donor/register" element={<DonorRegister />} />
        <Route path="/donor/dashboard" element={<DonorDashboard />} />
        <Route path="/donor/browse-cases" element={<BrowseCases />} />
        <Route path="/donor/donation-history" element={<DonationHistory />} />
        <Route path="/donor/support-ticket" element={<SupportTicket />} />
        <Route path="/donor/my-level" element={<MyLevel />} />
        <Route path="/donor/my-rewards" element={<MyRewards />} />
        <Route path="/donor/analytics" element={<Analytics />} />
        <Route path="/donor/profile" element={<DonorProfile />} />
        <Route path="/donor/notificationdropdown" element={<NotificationDropdown />} />
        <Route path="/donor/all-notifications" element={<AllNotifications />} />

        {/* ===== ADMIN ===== */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/studentmgmt" element={<StudentMGMT />} />
        <Route path="/admin/donations" element={<Donations />} />
        <Route path="/admin/donorlist" element={<DonorList />} />
        <Route path="/admin/ngolist" element={<NGOlist />} />
        <Route path="/admin/report" element={<Report />} />
        <Route path="/admin/donor-levels-rewards" element={<DonorLevels />} />
        <Route path="/admin/profile" element={<ProfilePage />} />
        <Route path="/admin/disputes" element={<Disputes />} />
        <Route path="/admin/sub-admins" element={<SubAdmins />} />
        <Route path="/admin/notifications" element={<Notifications />} />
        <Route path="/admin/blog-management" element={<BlogManagement />} />
        <Route path="/admin/support-system" element={<SupportSystem />} />


        {/* ===== NGO ===== */}
        <Route path="/ngo/auth" element={<NgoAuth />} />
        <Route path="/ngo/dashboard" element={<NgoDashboard />} />
        <Route path="/ngo/allcases" element={<NgoCaseVerification />} />
        <Route path="/ngo/donationtracking" element={<DonationTracking />} />
        <Route path="/ngo/ngofund" element={<NgoFundWallet />} />
        <Route path="/ngo/funddistribution" element={<FundDistribution />} />
        <Route path="/ngo/reports" element={<NgoReports />} />
        <Route path="/ngo/disputes" element={<NgoDisputes />} />
        <Route path="/ngo/profile" element={<NgoProfile />} />
        <Route path="/ngo/donorlevels" element={<DonorRewardsLevel />} />
        <Route path="/ngonotification" element={<NgoNotification />} />

        {/* Story Detail Page — :id is the story number (1–6) */}
         {/* <Route path="/storiessection" element={<StoriesSection />} /> */}
        <Route path="/stories/:id" element={<StoriesDetail />} />


        ///
        {/* ===== FALLBACK ===== */}
        <Route path="*" element={<NotFound />} />

      </Routes>

    </BaseUrlProvider >
  );
}

export default App;